import { h, render, hydrate } from 'preact'
import App from './containers/App'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const container = document.getElementById('js-projects-overview')

if ( container ) {
  const language = container.dataset.language
  // Cards rendered by projects-overview.twig are taken over, not rebuilt
  const mount = container.firstElementChild ? hydrate : render
  mount( <App language={language} />, container )
}



// WEBPACK FOOTER //
// ./src/js/projects/index.js